<template>
    <div>
        <ams-base-chart
            :chartTitle="`Count of ${label('Task')} by User and Status`"
            :chartType="ChartTypes.BAR"
            :data="chartData"
            :stacked="true"
        />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ChartTypes } from '../../../../../../enums';
import { useLabels } from '@/composables/LabelComposable';
//import { Colors } from '../../../../../../utilities/colors';
//import { toCapitalize } from '../../../../../../utilities';

const props = defineProps({
    jsonData: {
        type: Array,
    },
});

const chartData = ref([]);
const { label } = useLabels();

onMounted(() => {
    loadChartData();
});

const loadChartData = () => {
    chartData.value = props.jsonData
};
</script>
